// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CouponMemberReplaceCardReplaceCardResponse {
    static getAttributeTypeMap() {
        return CouponMemberReplaceCardReplaceCardResponse.attributeTypeMap;
    }
}
CouponMemberReplaceCardReplaceCardResponse.discriminator = undefined;
CouponMemberReplaceCardReplaceCardResponse.additionalProperties = false;
CouponMemberReplaceCardReplaceCardResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "ExtCardReplaceCardResultModel"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=couponMemberReplaceCardReplaceCardResponse.js.map